import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Avatar } from "@faire/web--source/slate/Avatar";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { trackRetailerTeamManagementMultiUserEvergreenHomepageBannerAvatarsClick } from "@faire/web-api--source/events/retailerTeamManagement/click/multiUserEvergreenHomepageBannerAvatars";
import { trackRetailerTeamManagementMultiUserEvergreenHomepageBannerView } from "@faire/web-api--source/events/retailerTeamManagement/view/multiUserEvergreenHomepageBanner";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import React from "react";
import styled from "styled-components";
import { TeamMembersModal } from "@faire/retailer/components/Modals/TeamMembersModal/TeamMembersModal";
import { useModalState } from "@faire/retailer-visitor-shared/hooks/useModalState";
export var Avatars = function(param) {
    var simpleImageTitle = param.simpleImageTitle, additionalUsers = param.additionalUsers;
    var _useModalState = useModalState(), isOpen = _useModalState.isOpen, openModal = _useModalState.openModal, closeModal = _useModalState.closeModal;
    var actionRef = useDoActionWhenVisible(function() {
        trackRetailerTeamManagementMultiUserEvergreenHomepageBannerView();
    });
    var handleAvatarClick = function() {
        trackRetailerTeamManagementMultiUserEvergreenHomepageBannerAvatarsClick();
        openModal();
    };
    var _simpleImageTitle_images;
    return /*#__PURE__*/ _jsxs(Column, {
        ref: actionRef,
        justify: "center",
        children: [
            isOpen ? /*#__PURE__*/ _jsx(TeamMembersModal, {
                onClose: closeModal
            }) : null,
            /*#__PURE__*/ _jsxs(AvatarRow, {
                align: "center",
                onClick: handleAvatarClick,
                children: [
                    ((_simpleImageTitle_images = simpleImageTitle.images) !== null && _simpleImageTitle_images !== void 0 ? _simpleImageTitle_images : []).map(function(image, index) {
                        var _image_url;
                        return /*#__PURE__*/ _jsx(AvatarWrapper, {
                            "data-test-id": "homepage-team-member-avatar-".concat(index),
                            $marginLeft: index === 0 ? 0 : -8,
                            children: /*#__PURE__*/ _jsx(TeamMemberAvatar, {
                                size: "x-small",
                                image: IImage.build({
                                    url: (_image_url = image.url) !== null && _image_url !== void 0 ? _image_url : ""
                                })
                            })
                        }, index);
                    }),
                    additionalUsers ? /*#__PURE__*/ _jsx(AdditionalUsersAvatar, {
                        children: /*#__PURE__*/ _jsx(Typography, {
                            variant: "labelSansMedium",
                            color: Core.text.inverse,
                            children: additionalUsers
                        })
                    }) : null
                ]
            })
        ]
    });
};
var AdditionalUsersAvatar = styled.div.withConfig({
    componentId: "sc-46a3cde2-0"
})([
    "width:",
    ";height:",
    ";background-color:",
    ";border:1px solid ",
    ";border-radius:50%;display:flex;align-items:center;justify-content:center;margin-left:",
    ";z-index:2;"
], getSpacing("4x"), getSpacing("4x"), Core.surface.default, Core.surface.subdued, getSpacing("-1x"));
var AvatarRow = styled(Row).withConfig({
    componentId: "sc-46a3cde2-1"
})([
    "width:fit-content;&:hover{cursor:pointer;}"
]);
var AvatarWrapper = styled.div.withConfig({
    componentId: "sc-46a3cde2-2"
})([
    "margin-left:",
    "px;"
], function(param) {
    var $marginLeft = param.$marginLeft;
    return $marginLeft;
});
var TeamMemberAvatar = styled(Avatar).withConfig({
    componentId: "sc-46a3cde2-3"
})([
    "border:1px solid ",
    ";"
], Core.surface.subdued);
